import React from 'react'
import { SERVICE_LABEL_WHOLESALER } from '../Helper/constants.js'
import SuccessMessage from '../Modules/SuccessMessage.jsx'
import { getWholesalerLabel } from '../Helper/helper.js'

function ProductInsights({
  productResults,
  wholesalerLabels,
  success,
  userSubscriptionProfile,
  handleSubscribe,
}) {
  const getFrequency = (frequency) => {
    switch (frequency) {
      case 'Daily':
        return '1'
      case 'Weekly':
        return '2'
      case 'Bi-Weekly':
        return '3'
      case 'Monthly':
        return '4'
      case 'Quarterly':
        return '5'
      case 'Occasional':
        return '6'
      default:
        return '0'
    }
  }
  return (
    productResults.length > 0 && (
      <React.Fragment>
        <h3 className="u-marginBottom3gu">
          Product Insights{' '}
          <span className="u-marginLeft1gu u-textNormal u-textSecondary">
            {/* placeholder for Product Insights description */}
          </span>
        </h3>
        {success && <SuccessMessage></SuccessMessage>}
        <div
          id="Insights-thought-leadership"
          className="Grid-striper u-marginHoriz2gu"
          data-analytics="cesc-Thought-Leadership"
        >
          {productResults
            .sort((a, b) =>
              (getFrequency(a.frequency) + a.name || '').localeCompare(
                getFrequency(b.frequency) + b.name || '',
                'en',
                {
                  sensitivity: 'base',
                }
              )
            )
            .map((productResult) => {
              getWholesalerLabel(
                wholesalerLabels,
                productResult.wholesalerLabel
              )

              return (
                <div
                  key={productResult.id}
                  className="Grid Grid--withGutter u-paddingHoriz1gu u-paddingVert3gu"
                >
                  <div className="u-size8of12 u-sm-sizeFull u-marginTop1gu">
                    <input
                      id={'thoughtCheckBox' + productResult.id}
                      checked={productResult.checked}
                      onChange={handleSubscribe}
                      value={productResult.id}
                      type="checkbox"
                      className="Subscription-checkbox"
                      data-analytics="cesc-subscribe-checkbox"
                    ></input>
                    <label htmlFor={'thoughtCheckBox' + productResult.id}>
                      <h4 className="u-marginLeft2gu u-marginRight2gu">
                        {productResult.name}
                        {userSubscriptionProfile.role ===
                          SERVICE_LABEL_WHOLESALER &&
                          productResult.wholesalerLabel && (
                            <div className="From-you u-marginBottom2gu u-marginLeft1gu u-inlineBlock u-bgColorLight u-paddingHoriz2gu u-textNormal">
                              <div className="u-textSizeMsrm1">
                                {
                                  (
                                    wholesalerLabels.find(
                                      (label) =>
                                        label.key ===
                                        productResult.wholesalerLabel
                                    ) || { label: '' }
                                  ).label
                                }
                              </div>
                            </div>
                          )}
                      </h4>
                    </label>
                    <p className="u-marginTop1gu u-marginLeft5gu">
                      {productResult.description}
                    </p>
                  </div>
                  <div className="u-size2of12 u-sm-size3of12 u-marginTop1gu u-sm-marginTop3gu u-sm-marginLeft5gu u-textCenter u-sm-textLeft">
                    <h5 className="u-textNoTransform u-paddingVert2gu u-textSizeMsr">
                      {productResult.frequency}
                    </h5>
                  </div>
                  <div className="u-size2of12 u-sm-size3of12 u-sm-marginTop2gu u-textCenter u-sm-textLeft">
                    {productResult.previewLink && (
                      <a
                        className="Button Button--tertiary Preview-btn u-textNoTransform u-textKernDefault"
                        data-tracking="secondary"
                        href={productResult.previewLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Preview
                      </a>
                    )}
                  </div>
                </div>
              )
            })}
        </div>
      </React.Fragment>
    )
  )
}
// ProductResults.propTypes = {
//   productResults: PropTypes.array,
//   wholesalerLabels: PropTypes.array.isRequired,
//   success: PropTypes.bool,
//   userSubscriptionProfile: PropTypes.object.isRequired,
//   handleSubscribe: PropTypes.func.isRequired,
// }
export default ProductInsights
